import routerOptions0 from "/builds/aschehoug/universitetsforlaget/kunne-spa/node_modules/.pnpm/nuxt@3.18.1_@types+node@20.19.11_@vue+compiler-sfc@3.5.20_eslint@9.34.0_rollup@2.79.2_tsx@4.2_xxcawlhva3yi5szyten2c74h24/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/builds/aschehoug/universitetsforlaget/kunne-spa/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}